import { CKEditor } from '@ckeditor/ckeditor5-react';
import usePermission from '@/app/hooks/usePermission';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { t } from 'i18next';
import React, { useMemo } from 'react';
import { FiSend, FiX } from 'react-icons/fi';
import { LessonBoardFile, LessonBoardFileName, LessonBoardFilePreview, LessonBoardFooter, LessonBoardForm, LessonBoardRichTextEditor } from '@/components/custom/lesson';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { IconWrapper } from '@/components/custom/icon';

export function AuditoriumViewFormMessage(props) {
  const { messageForm, lessonId, createMessage, auditoriumId, auditorium, currentUser, isAdmin } = props;

  const hasFile = messageForm?.values?.file;

  const handleSubmit = e => {
    e.preventDefault();
    if (!messageForm.values.body && !hasFile) {
      return;
    }
    createMessage(lessonId, messageForm.values, auditoriumId);
    messageForm.setFieldValue('body', '');
    messageForm.setFieldValue('file', null);
  };

  const handleFileRemove = () => {
    messageForm.setFieldValue('file', null);
  };

  const shouldRenderOptions = useMemo(() => {
    if (auditorium?.['authored-by-user'] === true) {
      if (auditorium?.creator?.id !== currentUser.id) {
        return false;
      } else return true;
    }

    if (auditorium?.['authored-by-user'] === false) {
      if (isAdmin && usePermission('Interagir com monitoria', 'Monitorias')) {
        return true;
      } else return false;
    }
  }, [auditorium, isAdmin]);

  return (
    <LessonBoardFooter>
      <LessonBoardForm
        onSubmit={handleSubmit}
        onClick={() => {
          messageForm.setFieldValue(body, messageForm.values.body);
        }}
      >
        <LessonBoardRichTextEditor>
          {shouldRenderOptions && (
            <CKEditor
              editor={Editor}
              data={messageForm.values.body}
              config={{
                placeholder: t('auditorium.placeholderWriteMessageHere')
              }}
              onChange={(event, editor) => {
                const data = editor.getData();
                messageForm.setFieldValue('body', data);
              }}
            />
          )}

          <LessonBoardFile>
            {shouldRenderOptions && (
              <Label
                customFileInput
                className="shrink-0"
                style={{ pointerEvents: hasFile ? 'none' : 'all' }}
              >
                <Input
                  type="file"
                  name="file"
                  id="file"
                  onChange={e => messageForm.setFieldValue('file', e.target.files[0])}
                />

                <Button
                  variant="outline"
                  size="sm"
                  disabled={hasFile}
                  asChild
                >
                  <span>{t('auditorium.buttonAttachFile')}</span>
                </Button>
              </Label>
            )}

            {hasFile && (
              <LessonBoardFilePreview>
                <LessonBoardFileName>{messageForm?.values?.file?.name ?? messageForm?.values?.file?.url}</LessonBoardFileName>
                <IconWrapper
                  aria-label="Apagar"
                  className="cursor-pointer"
                  onClick={handleFileRemove}
                >
                  <FiX
                    aria-hidden="true"
                    className="card__icon"
                  />
                </IconWrapper>
              </LessonBoardFilePreview>
            )}
          </LessonBoardFile>
        </LessonBoardRichTextEditor>

        {shouldRenderOptions && (
          <Button
            type="submit"
            size="icon"
          >
            <FiSend />
          </Button>
        )}
      </LessonBoardForm>
    </LessonBoardFooter>
  );
}
